import React, { useEffect } from 'react'
import styled from 'styled-components'
import ErrorOutline from '@mui/icons-material/ErrorOutline'

import Modal from 'components/Modal'
import ModalButton from 'components/Modal/Button'

import Apptentive from 'helpers/apptentive'
import { StackedButtonContainer } from 'styles/shared'
import { color } from 'styles/colors'
import GA4 from 'helpers/ga4'

import { useNavigate } from 'react-router-dom'

type Props = {
  closeCallback: (reloadPage) => void
  dealerId: number
  error: string
}

const HEHMFailureModal = ({ dealerId, closeCallback, error } : Props) => {
  const navigate = useNavigate()

  const onClickClose = () => {
    closeCallback(false)
  }

  const onClickTryAgain = () => {
    navigate(`/ehmkt/options/${dealerId}`)
  }

  useEffect(() => {
    Apptentive.sendEvent('pmk_acct_failed')

    GA4.sendEvent({
      action: 'PMK Account Failed',
      category: 'PMK Settings',
      label: `Failure Reason: ${error}`
    })
  }, [error])

  return (
    <Modal variant="sm" isDisplayed closeCallback={() => closeCallback(false)}>
      <S.Top>
        <S.ProductLogo src="/img/pmk-logo.png" alt="PMK logo" />
        <div />
      </S.Top>
      <S.FailureBox>
        <S.ErrorOutline fontSize="large" />
        <S.FailureText>Error: {error}</S.FailureText>
      </S.FailureBox>
      <p>There was an issue with your account creation.</p>
      <p>Please try again or call Support <u>844-359-0270</u> for assistance.</p>

      <S.StackedButtonContainer noBorder>
        <ModalButton decoration="secondary" text="Cancel" styles={{ button: { marginLeft: 15 } }} onPress={onClickClose} />
        <ModalButton decoration="positive" text="Try Again" styles={{ button: { marginLeft: 15 } }} onPress={onClickTryAgain} />
      </S.StackedButtonContainer>
    </Modal>
  )
}

export default HEHMFailureModal

const S = {
  ErrorOutline: styled(ErrorOutline)`
    color: ${color('premiumModalFailureText')};
    padding-right: 3px;
  `,
  Explanation: styled.li`
    margin: 10px 0 0 0;
    padding-right: 5px;
    padding-left: 5px;
  `,
  ProductLogo: styled.img`
    height: 50px;
    margin-bottom: 25px;
  `,
  FailureBox: styled.div`
    display: flex;
    align-items: center;
  `,
  FailureText: styled.div`
    font-size: 18px;
    font-weight: bold;
    color: ${color('premiumModalFailureText')};
    text-transform: none;
  `,
  StackedButtonContainer: styled(StackedButtonContainer)`
    margin-top: auto;
  `,
  Top: styled.div`
    display: flex;
    justify-content: center;
    padding-top: 10px;
  `
}
